import { ClickStreamUserParams } from '@/modules/Metrix/adapters/ClickStream';
import { FirstDMPPacketData } from '@/modules/Metrix/adapters/OneDMP';
import * as clickStream from '@/modules/Metrix/adapters/ClickStream';
import * as yandexMetrika from '@/modules/Metrix/adapters/YandexMetrika';
import * as oneDMP from '@/modules/Metrix/adapters/OneDMP';

export enum ServerType {
    PROD = 'welcome_stable',
}

/**
 * Раздельный установщик метрик
 */
export class LazyMetrixInstaller {
    protected d_mutex!: Promise<void>;
    protected y_mutex!: Promise<void>;
    protected o_mutex!: Promise<void>;

    constructor(protected readonly metrika_config: any) {}

    public divolte(userParams: ClickStreamUserParams) {
        if (!this.d_mutex) {
            // When YM is installed, clientID will be a string
            const bootstrapParams = Object.assign(
                { YMClientID: yandexMetrika.getClientID()! },
                userParams
            );
            this.d_mutex = clickStream.install(bootstrapParams);
        }

        return this.d_mutex;
    }

    public metrika(serverType: ServerType) {
        if (!this.y_mutex) {
            this.y_mutex = yandexMetrika.install(
                this.metrika_config,
                serverType
            );
        }

        return this.y_mutex;
    }

    public oneDMP(first_dmp_packet_data: FirstDMPPacketData) {
        if (!this.o_mutex) {
            this.o_mutex = oneDMP.install(first_dmp_packet_data);
        }

        return this.o_mutex;
    }
}
